import I18n from 'i18n-js/index.js.erb'

document.addEventListener("turbolinks:load", () => {
  I18n.defaultLocale = "fr";
  I18n.locale = $('#locale').data()['locale'];

  "use strict"; // Start of use strict
  if ($('#users-datatable').length) {
    var language = {
      "processing": I18n.t("js.users_datatable.processing"),
      "lengthMenu": "_MENU_",
      "info": I18n.t("js.users_datatable.info", { start: "_START_", end: "_END_", total: "_TOTAL_" }),
      "infoEmpty": I18n.t("js.users_datatable.infoEmpty"),
      "infoFiltered": I18n.t("js.users_datatable.infoFiltered", { max: "_MAX_"}),
      "infoPostFix": "",
      "loadingRecords": I18n.t("js.users_datatable.loadingRecords"),
      "zeroRecords": I18n.t("js.users_datatable.zeroRecords"),
      "emptyTable": I18n.t("js.users_datatable.emptyTable"),
      "select": {
        "rows": "<br> %d " + I18n.t("js.users_datatable.select")
       }
    };

    var columns = [
      {
        "data": "id",
        "visible": false
      },
      {
        "data": "check_box",
        "sortable": false,
        "className": "user-select-checkbox"
      },
      {
        "data": "display_name"
      },
      {
        "data": "first_name",
        visible: false
      },
      {
        "data": "last_name",
        visible: false
      },
      {
        "data": "origin"
      },
      {
        "data": "activated_at"
      }
    ];

    var usersTable = $('#users-datatable').DataTable({
      "processing": true,
      "serverSide": true,
      "searching": true,
      "dom": 'Blirtp',
      "ajax": {
        "url": $('#users-datatable').data('source')
      },
      "select": {
        "style": "multi",
        "selector": ".user-select-checkbox input"
      },
      "pagingType": "simple_numbers",
      "columns": columns,
      "language": language,
        aLengthMenu: [
        [25, 50, 100, 1000, -1],
        [25, 50, 100, 1000, I18n.t("js.users_datatable.all")]
      ],
      iDisplayLength: 25
    });

    // Filters

    $('#user-origin-filter').on('change', function () {
      usersTable.columns(5).search( this.value ).draw();
    });

    // Search
    $('#user-search').on('keyup', function() {
      usersTable.search($(this).val()).draw() ;
    })

    // Display remove button at the "right" place
    var removeButton = document.getElementById('index-users-delete-button');
    var copyRemoveButton = removeButton.cloneNode(true);
    $('#users-datatable_length').append(copyRemoveButton);
    copyRemoveButton.style.display = 'block';
    removeButton.remove();
    setDeleteButtonState(usersTable);
    buildDeleteModalTitle(usersTable);

    // Select all / deselect all
    usersTable.on("click", "#users-select-all", function(e) {
        if ($('#users-select-all:checked').length == 0) {
            usersTable.rows().deselect();
            $(".user-select-checkbox input").prop("checked", false);
            $("#users-select-all").prop("checked", false);
        } else {
            usersTable.rows().select();
            $(".user-select-checkbox input").prop("checked", true);
            $("#users-select-all").prop("checked", true);
        }
        buildDeleteModalTitle(usersTable);
        setDeleteButtonState(usersTable);
    }).on("select deselect", function(e, dt, type, indexes) {
        if (usersTable.rows({ selected: true }).count() !== usersTable.rows().count()) {
            $("#users-select-all").prop("checked", false);
        } else {
            $("#users-select-all").prop("checked", true);
        }
        buildDeleteModalTitle(usersTable);
        setDeleteButtonState(usersTable);
        e.preventDefault();
    });

    // Delete users section
    $('#index-users-delete-button').on("click", function() {
        $("#users-delete-modal").modal('show');
        $(".close-users-delete-modal ").on("click", function(){
            $("#users-delete-modal").modal('hide');
        });
    })

    function buildDeleteModalTitle(usersTable) {
        var usersCount = usersTable.rows({ selected: true }).count()
        if (usersCount > 1) {
            $('#delete-modal-title').text(I18n.t('js.users_datatable.delete') + ' ' + usersCount + ' ' + I18n.t('js.users_datatable.users'))
        } else {
            $('#delete-modal-title').text('Supprimer ' + usersCount + ' utilisateur')
        }
    }

    function setDeleteButtonState(usersTable) {
        if (usersTable.rows({ selected: true }).count() > 0) {
            $('#index-users-delete-button').prop('disabled', false)
        } else {
            $('#index-users-delete-button').prop('disabled', true)
        }
    }

    $('#modal-delete-users').on("click", function(e) {
        $.ajax($(this).data()['actionUrl'], {
            type: 'DELETE',
            data: { user: { id: usersTable.rows({ selected: true }).data().pluck('id').join(',') } },
            success: function (data, status, xhr) {
                usersTable.draw()
            },
            error: function (jqXhr, textStatus, errorMessage) {
                // TODO
            }
        });
        e.preventDefault();
    })
  }
})
